import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

function SEO({
  description,
  lang,
  meta,
  keywords,
  title,
  location,
  image = null,
  course_lang = null,
}) {
  if (image === null) {
    image =
      "https://res.cloudinary.com/ie1/image/upload/v1607345658/vtutor/meta-image_hpc70z.jpg";
  }
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription =
          description || data.site.siteMetadata.description;
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            link={[
              {
                rel: `alternate`,
                href: `https://vtutor.com${location.en}`,
                hrefLang: `x-default`,
              },
              {
                rel: `alternate`,
                href: `https://vtutor.com${location.en}`,
                hrefLang: `en`,
              },
              {
                rel: `alternate`,
                href: `https://vtutor.com${location.es}`,
                hrefLang: `es`,
              },
              {
                rel: `canonical`,
                href:
                  course_lang === null
                    ? `https://vtutor.com${location.en}`
                    : `https://vtutor.com${location[course_lang]}`,
              },
            ]}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                property: "og:image",
                content: image,
              },
              {
                property: "og:image:secure_url",
                content: image,
              },
              {
                itemprop: "image",
                content: image,
              },
              {
                property: "og:image:width",
                content: "570",
              },
              {
                property: "og:image:height",
                content: "460",
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
              {
                name: `twitter:image`,
                content: image,
              },
              {
                name: `twitter:card`,
                content: `summary_large_image`,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}
          />
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`;
